import { debounce, get } from "lodash";
import PropTypes from "prop-types";
import React from "react";
import { Redirect, Route, Switch } from "react-router";
import { withRouter } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { compose, lifecycle, withHandlers, withState } from "recompose";
import { Container, Loader, Menu, Message, Segment } from "semantic-ui-react";
import Registries from "./../registries";
import Registry from "./../registry";
import CaseStatuses from "./../case-statuses";
import { OrganizationsApiService } from "./../../api";

const Organization = ({ isLoading, match, notFoundError, organization }) => {
  return (
    <Container>
      <Menu color="orange" pointing>
        <Menu.Item as={NavLink} to={`${match.url}/statusy-spraw`}>
          Statusy spraw
        </Menu.Item>
        <Menu.Item as={NavLink} to={`${match.url}/rejestry`}>
          Rejestry
        </Menu.Item>
        {organization && (
          <Menu.Item header position="right">
            {get(organization, "name")}
          </Menu.Item>
        )}
      </Menu>
      <Segment>
        {isLoading && (
          <Loader active content="Ładowanie danych..." inline="centered" />
        )}
        {organization && (
          <Switch>
            <Route
              render={(props) => (
                <CaseStatuses {...props} organization={organization} />
              )}
              path={`${match.path}/statusy-spraw`}
            />
            <Route
              component={Registries}
              exact
              path={`${match.path}/rejestry`}
            />
            <Route
              component={Registry}
              path={`${match.path}/rejestry/:registry`}
            />
            <Redirect from={`${match.url}`} to={`${match.url}/statusy-spraw`} />
          </Switch>
        )}
        {notFoundError && (
          <Message
            content="Nie znaleziono jednostki"
            error
            header="Wystąpił błąd"
            icon="warning sign"
          />
        )}
      </Segment>
    </Container>
  );
};

Organization.propTypes = {
  match: PropTypes.object.isRequired,
  organization: PropTypes.object,
};

const enhance = compose(
  withRouter,
  withState("organization", "setOrganization"),
  withState("isLoading", "setLoading", false),
  withState("notFoundError", "setNotFoundError", false),
  withHandlers({
    onLoadOrganization: ({
      setLoading,
      setNotFoundError,
      setOrganization,
    }) => async (organizationId) => {
      const debouncedSetLoading = debounce(setLoading, 300);
      debouncedSetLoading(true);
      try {
        const organization = await OrganizationsApiService.getOrganization(
          organizationId
        );
        setNotFoundError(false);
        setOrganization(organization);
      } catch (error) {
        setNotFoundError(true);
      } finally {
        debouncedSetLoading.cancel();
        setLoading(false);
      }
    },
  }),
  lifecycle({
    async componentDidMount() {
      const organizationId = get(this.props, "match.params.organization");
      this.props.onLoadOrganization(organizationId);
    },
    async componentDidUpdate(prevProps) {
      const prevOrganizationId = get(prevProps, "match.params.organization");
      const organizationId = get(this.props, "match.params.organization");
      if (prevOrganizationId !== organizationId) {
        this.props.onLoadOrganization(organizationId);
      }
    },
  })
);

export default enhance(Organization);



// WEBPACK FOOTER //
// ./src/containers/organization/Organization.js